import { render, staticRenderFns } from "./PaidAll.vue?vue&type=template&id=0228e366&"
import script from "./PaidAll.vue?vue&type=script&lang=js&"
export * from "./PaidAll.vue?vue&type=script&lang=js&"
import style0 from "./PaidAll.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports